import { GET_PROFILE_REQUESTED, GET_UPDATEPROFILE_REQUESTED, GET_VERIFY_PROFILE_REQUESTED } from "resources/actionTypes";

export function getProfile(data) {
    return {
        type:GET_PROFILE_REQUESTED,
        payload:data ? data : {}
    };
}
export function updateProfile(userUpdateProfile,toggle){
    const data = {
        userUpdateProfile :userUpdateProfile,
        setConfirmModal: toggle,
    }
    return{
        type:GET_UPDATEPROFILE_REQUESTED,
        payload:data,
    };
}
export function verifyProfile(userVerifyProfile,handleClose){
    const data = {
        userVerifyProfile: userVerifyProfile,
        setCloseModal:handleClose,
    }
    return{
        type:GET_VERIFY_PROFILE_REQUESTED,
        payload:data,
    }
}